import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelReservationAvailabilityRequest,
  failReservationAvailability,
  setReservationAvailability,
  setReservationAvailabilityFromApi,
  updateReservationAvailability,
  updateReservationAvailabilityFromApi,
} from './reservation-availability.actions';

/**
 * Service to handle async ReservationAvailability actions
 */
@Injectable()
export class ReservationAvailabilityEffect {
  /**
   * Set the state with the reply content, dispatch failReservationAvailability if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setReservationAvailabilityFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setReservationAvailability({ model: reply, requestId: action.requestId }),
        (error, action) => of(failReservationAvailability({ error, requestId: action.requestId })),
        cancelReservationAvailabilityRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failReservationAvailability if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateReservationAvailabilityFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateReservationAvailability({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failReservationAvailability({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
